import { useMemo } from 'react';
import { defineColumn } from '../../../components/tanstack-table/column';
import { TanStackTable } from '../../../components/tanstack-table/table';
import type { ProductOrderMatch } from '../../../data/receiving';
import {
  emDashIfEmpty,
  productHeadColumns,
  productTailColumns,
  vendorColumn,
} from './product-columns';

const matchProduct = (m: ProductOrderMatch) => m.product;

const itemCodeColumn = defineColumn<ProductOrderMatch>({
  id: 'Item code',
  minWidth: 100,
  maxWidth: 160,
  accessorFn: (m) => emDashIfEmpty(m.product.item_code || m.product.raw_item_code),
  cell: ({ value }) => <span className="font-mono">{value}</span>,
});

export function MatchedProductsTable({
  rows,
  vendorNames,
}: {
  rows: ProductOrderMatch[];
  vendorNames?: Map<string, string>;
}) {
  const columns = useMemo(() => {
    const head = productHeadColumns<ProductOrderMatch>(matchProduct);
    const tail = productTailColumns<ProductOrderMatch>(matchProduct);
    const showVendor = (vendorNames?.size ?? 0) > 1;

    return showVendor
      ? [
          ...head,
          vendorColumn<ProductOrderMatch>(matchProduct, (id) => vendorNames?.get(id) ?? ''),
          itemCodeColumn,
          ...tail,
        ]
      : [...head, itemCodeColumn, ...tail];
  }, [vendorNames]);

  return <TanStackTable data={rows} columns={columns} />;
}
